import { Component } from '@angular/core';

@Component({
    selector: 'login-layout',
    template: ` <router-outlet></router-outlet> `,
})
export class LoginLayoutComponent {}
